import Socket from "sockjs-client";
import Stomp from "stompjs";

class StompClient {
  constructor(socketUrl) {
    this.socketUrl = socketUrl;
    this.socket = new Socket(socketUrl);
    this.stompClient = Stomp.over(this.socket);
    this.stompClient.debug = () => {};
  }
  connect(options = {}, onSocketConnected, onSocketError) {
    this.stompClient.connect(options, onSocketConnected, onSocketError);
  }

  subscribe(subscriptionUrl, onMessageReceived) {
    this.stompClient.subscribe(subscriptionUrl, onMessageReceived);
  }

  send(url, message) {
    this.stompClient.send(url, {}, JSON.stringify(message));
  }

  disconnect() {
    if (this.stompClient && this.stompClient.connected) {
      this.stompClient.disconnect();
    }
  }
}

export default StompClient;
